import React from "react";
import { Stack, Text, Textarea } from "@chakra-ui/react";
import { walletTextFieldSx } from "../artistWallet/dialogStyles";
import { TierSelect, CurrencySelect, DurationSelect } from "./CreateFormFields";

/**
 * Returns the initial state for the free creation form.
 * @returns {Object}
 */
export function buildFreeInitialState() {
    return { subscription_type: "blue", duration_months: 3, currency: "EUR", reason: "" };
}

/**
 * Builds the API payload for POST /create-free from form state and target user.
 * @param {Object} form - Free form state
 * @param {number} userId - Target user ID
 * @returns {Object} Payload ready for the API
 */
export function buildFreePayload(form, userId) {
    return {
        owner_type: "user",
        owner_id: userId,
        subscription_type: form.subscription_type,
        duration_months: form.duration_months,
        currency: form.currency,
        reason: form.reason.trim() || undefined,
    };
}

/**
 * Validates the free form state. Returns null if valid, an error message otherwise.
 * @param {Object} form - Free form state
 * @returns {string|null}
 */
export function validateFreeForm(form) {
    if (!form.subscription_type) return "Sélectionne un type d'abonnement";
    if (!form.currency) return "Sélectionne une devise";
    if (!form.duration_months || form.duration_months < 1 || form.duration_months > 12) {
        return "La durée doit être comprise entre 1 et 12 mois";
    }
    return null;
}

/**
 * Free subscription creation form. Controlled by parent state.
 * @param {Object} props
 * @param {Object} props.form - Form state object
 * @param {Function} props.setForm - State setter (receives the updated form)
 * @returns {React.ReactElement}
 */
function CreateFreeForm({ form, setForm }) {
    const update = (key, value) => setForm({ ...form, [key]: value });
    return (
        <Stack spacing={4}>
            <Text color="rgba(255, 255, 255, 0.7)" fontSize="0.85rem">
                Crée un abonnement gratuit (coupon 100 % off appliqué côté Stripe). Le compte est immédiatement actif et un email est envoyé à l'utilisateur.
            </Text>
            <TierSelect value={form.subscription_type} onChange={(v) => update("subscription_type", v)} />
            <DurationSelect value={form.duration_months} onChange={(v) => update("duration_months", v)} />
            <CurrencySelect value={form.currency} onChange={(v) => update("currency", v)} />
            <Textarea rows={2} placeholder="Raison (optionnelle)"
                value={form.reason} onChange={(e) => update("reason", e.target.value)} {...walletTextFieldSx} />
        </Stack>
    );
}

export default CreateFreeForm;
